// src/admin/pages/AdminOrders.js
import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import {
    FaSearch,
    FaSort,
    FaSortUp,
    FaSortDown,
    FaEye,
    FaTrash,
    FaRegCalendarAlt,
    FaCalendarAlt,
    FaBoxOpen,
    FaInbox
} from "react-icons/fa";
import { FiChevronDown } from "react-icons/fi";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import { getAdminOrders, deleteAdminOrder } from "../../services/adminOrders.api";
import { FaGlobe, FaWhatsapp, FaStore } from "react-icons/fa";

function AdminOrders() {
    const [isOpen, setIsOpen] = useState(false);

    const [orders, setOrders] = useState([]);
    const [search, setSearch] = useState("");
    const [statusFilter, setStatusFilter] = useState("All");
    const [sourceFilter, setSourceFilter] = useState("All");
    const [loading, setLoading] = useState(true);

    const [searchOpen, setSearchOpen] = useState(false);

    const [sortBy, setSortBy] = useState(null);
    const [sortDirection, setSortDirection] = useState("asc");


    const [sortOpen, setSortOpen] = useState(false);
    const [sortField, setSortField] = useState("date");

    const [dateOverlayOpen, setDateOverlayOpen] = useState(false);

    const [deleteId, setDeleteId] = useState(null);

    const [selectedOrders, setSelectedOrders] = useState([]);

    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const { lang } = useContext(AdminLanguageContext);

    const [totalCount, setTotalCount] = useState(0);
    const [showToast, setShowToast] = useState(false);

    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    
    const [customRangeStart, setCustomRangeStart] = useState(null);
const [customRangeEnd, setCustomRangeEnd] = useState(null);
const [customCalendarBaseDate, setCustomCalendarBaseDate] = useState(new Date());
const [customCalendarOffset, setCustomCalendarOffset] = useState(0);

    const [expandedStatus, setExpandedStatus] = useState({});

    const [analyticsOpen, setAnalyticsOpen] = useState(true);

    const [actionsOpen, setActionsOpen] = useState(false);

    const [analyticsPeriod, setAnalyticsPeriod] = useState("today");
    const [analyticsOverlayOpen, setAnalyticsOverlayOpen] = useState(false);

    const [customerOverlay, setCustomerOverlay] = useState(null);

    const [totalOverlay, setTotalOverlay] = useState(null);

    const ADMIN_ORDERS_PAGE_KEY = "adminOrdersCurrentPage";

    const getValidPage = (value) => {
      const n = Number(value || 1);
      return Number.isFinite(n) && n > 0 ? Math.floor(n) : 1;
    };

    const getInitialPage = () => {
      const urlPage = searchParams.get("page");
      const savedPage = sessionStorage.getItem(ADMIN_ORDERS_PAGE_KEY);
      return getValidPage(urlPage || savedPage || 1);
    };

    const [currentPage, setCurrentPage] = useState(getInitialPage);
    const rowsPerPage = 10;

    useEffect(() => {
      const urlPage = searchParams.get("page");
      const savedPage = sessionStorage.getItem(ADMIN_ORDERS_PAGE_KEY);
      const nextPage = getValidPage(urlPage || savedPage || 1);

      if (nextPage !== currentPage) {
        setCurrentPage(nextPage);
      }

      if (!urlPage && nextPage > 1) {
        setSearchParams((prev) => {
          const params = new URLSearchParams(prev);
          params.set("page", String(nextPage));
          return params;
        });
      }
    }, [searchParams, currentPage, setSearchParams]);

    const goToOrdersPage = (nextPage) => {
      const rawNext = typeof nextPage === "function" ? nextPage(currentPage) : nextPage;
      const safePage = getValidPage(rawNext);

      setCurrentPage(safePage);

      if (safePage <= 1) {
        sessionStorage.removeItem(ADMIN_ORDERS_PAGE_KEY);
      } else {
        sessionStorage.setItem(ADMIN_ORDERS_PAGE_KEY, String(safePage));
      }

      setSearchParams((prev) => {
        const params = new URLSearchParams(prev);

        if (safePage <= 1) {
          params.delete("page");
        } else {
          params.set("page", String(safePage));
        }

        return params;
      });
    };

    const didMountOrderFiltersRef = useRef(false);

    const orderSourceIcon = (source) => {
    const base = "text-gray-500";

  switch (source) {
    case "website":
      return <FaGlobe title="Website" className={base} />;
    case "whatsapp":
      return <FaWhatsapp title="WhatsApp" className={base} />;
    case "store":
      return <FaStore title="Store" className={base} />;
    default:
      return null;
  }
};

    const TEXT = {
        EN: {
            title: "Orders",
            searchPlaceholder: "Search by Order ID or Customer...",
            all: "All",
            pending: "Pending",
            paid: "Paid",
            shipped: "Shipped",
            delivered: "Delivered",
            cancelled: "Cancelled",
            refunded: "Refunded",
            orderId: "Order ID",
            customer: "Customer",
            total: "Total",
            status: "Status",
            date: "Date",
            actions: "Actions",
            loading: "Loading orders...",
            noOrders: "No orders found.",
            view: "View",
            delete: "Delete",
            prev: "Prev",
            next: "Next",
            deleteTitle: "Delete Order?",
            deleteText: "This action cannot be undone.",
            cancel: "Cancel",
            showAnalytics: "Show analytics bar",
            hideAnalytics: "Hide analytics bar",
            createOrder: "Create order",

            today: "Today",
            last7Days: "Last 7 days",
            last30Days: "Last 30 days",

            orders: "Orders",
            revenue: "Revenue",
            avgOrder: "Avg order",

            deliveredLabel: "Delivered",
            cancelledLabel: "Cancelled",
            paidLabel: "Paid",

            source: "Source",
            shipping: "Shipping",
            emptyTitle: "No orders yet",
emptyDesc: "Orders will appear here once customers place them.",
clearFilters: "Clear filters",

            sortBy: "Sort by",
            orderNumber: "Order number",
            customerName: "Customer name",
            orderStatus: "Order status",
            totalLabel: "Total",
            sourceLabel: "Source",

            oldestToNewest: "Oldest to newest",
            lowestToHighest: "Lowest to highest",
            ascending: "Ascending",
            az: "A-Z",
            za: "Z-A",

            newestToOldest: "Newest to oldest",
            highestToLowest: "Highest to lowest",
            descending: "Descending",

            clearSourceFilter: "Clear source filter",
            resetDate: "Reset date",
            customDate: "Custom date",
            extraFee: "Extra fee",

            bulkDeleteWarning:
            "You are about to delete multiple orders. This action cannot be undone.",
            todayAnalytics: "See analytics for today's orders",
            weekAnalytics: "See analytics for last 7 days orders",
            monthAnalytics: "See analytics for last 30 days orders",
            ordersInfo: "Shows how many orders were created in the selected period.",
            revenueInfo: "Shows the total sales amount from orders in the selected period.",
            avgOrderInfo: "Shows the average value per order during the selected period.",
            pendingInfo: "Pending orders are waiting to be packed and shipped.",
            deliveredInfo: "Delivered orders are the orders successfully received by customers.",
            cancelledInfo: "Cancelled orders are the orders that were stopped before completion.",
            paidInfo: "Paid orders are successfully completed and confirmed payments.",
        },
        AR: {
            title: "الطلبات",
            showAnalytics: "إظهار شريط التحليلات",
            hideAnalytics: "إخفاء شريط التحليلات",
            createOrder: "إنشاء طلب",
            extraFee: "رسوم إضافية",

            today: "اليوم",
            last7Days: "آخر 7 أيام",
            last30Days: "آخر 30 يوم",

            orders: "الطلبات",
            revenue: "الإيرادات",
            avgOrder: "متوسط الطلب",

            deliveredLabel: "تم التسليم",
            cancelledLabel: "ملغي",
            paidLabel: "مدفوع",

            source: "المصدر",
            shipping: "الشحن",
            emptyTitle: "لا توجد طلبات بعد",
emptyDesc: "ستظهر الطلبات هنا عند قيام العملاء بإنشاء طلبات.",
clearFilters: "مسح الفلاتر",

            sortBy: "ترتيب حسب",
            orderNumber: "رقم الطلب",
            customerName: "اسم العميل",
            orderStatus: "حالة الطلب",
            totalLabel: "الإجمالي",
            sourceLabel: "المصدر",
            az: "أ-ي",
            za: "ي-أ",

            oldestToNewest: "الأقدم إلى الأحدث",
            lowestToHighest: "الأقل إلى الأعلى",
            ascending: "تصاعدي",

            newestToOldest: "الأحدث إلى الأقدم",
            highestToLowest: "الأعلى إلى الأقل",
            descending: "تنازلي",

            clearSourceFilter: "إزالة فلتر المصدر",
            resetDate: "إعادة تعيين التاريخ",
            customDate: "تاريخ مخصص",

            bulkDeleteWarning:
            "أنت على وشك حذف عدة طلبات. لا يمكن التراجع عن هذا الإجراء.",
            searchPlaceholder: "بحث برقم الطلب أو اسم العميل...",
            all: "الكل",
            pending: "قيد الانتظار",
            paid:"مدفوع",
            shipped: "تم الشحن",
            delivered: "تم التسليم",
            cancelled: "ملغي",
            orderId: "رقم الطلب",
            customer: "العميل",
            total: "الإجمالي",
            status: "الحالة",
            date: "التاريخ",
            actions: "الإجراءات",
            loading: "جاري تحميل الطلبات...",
            noOrders: "لا توجد طلبات.",
            view: "عرض",
            delete: "حذف",
            prev: "السابق",
            next: "التالي",
            deleteTitle: "حذف الطلب؟",
            deleteText: "لا يمكن التراجع عن هذا الإجراء.",
            cancel: "إلغاء",
            refunded: "مسترجع",
            todayAnalytics: "عرض تحليلات طلبات اليوم",
            weekAnalytics: "عرض تحليلات آخر 7 أيام",
            monthAnalytics: "عرض تحليلات آخر 30 يوم",
            ordersInfo: "يعرض عدد الطلبات التي تم إنشاؤها خلال الفترة المحددة.",
            revenueInfo: "يعرض إجمالي المبيعات من الطلبات خلال الفترة المحددة.",
            avgOrderInfo: "يعرض متوسط قيمة الطلب الواحد خلال الفترة المحددة.",
            pendingInfo: "الطلبات المعلّقة هي الطلبات التي ما زالت بانتظار التجهيز والشحن.",
            deliveredInfo: "الطلبات المسلّمة هي الطلبات التي استلمها العملاء بنجاح.",
            cancelledInfo: "الطلبات الملغية هي الطلبات التي تم إيقافها قبل اكتمالها.",
            paidInfo: "الطلبات المدفوعة هي الطلبات التي تم تأكيد دفعها بنجاح.",
        },
    }[lang];

    const ORDER_STATUSES = [
  "pending",
  "paid",
  "shipped",
  "delivered",
  "cancelled",
  "refunded",
];


    const formatDate = (date) => {
  if (!date) return "";

  return new Date(date).toLocaleDateString(lang === "AR" ? "ar" : "en", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

  const statusColor = (status) => {
  switch (status) {
    case "pending":
      return "bg-gray-100 text-gray-900 border border-gray-200";
    case "paid":
      return "bg-gray-100 text-gray-800 border border-gray-200";
    case "shipped":
      return "bg-gray-100 text-gray-900 border border-gray-200";
    case "delivered":
      return "bg-gray-100 text-gray-900 border border-gray-200";
    case "cancelled":
      return "bg-gray-100 text-gray-500 border border-gray-200";
    default:
      return "bg-gray-100 text-gray-600 border border-gray-200";
  }
};

const statusDotColor = (status) => {
  switch (status) {
    case "pending":
      return "bg-amber-500";     // yellow
    case "paid":
      return "bg-emerald-500";   // green
    case "shipped":
      return "bg-blue-500";      // blue
    case "delivered":
      return "bg-green-600";     // darker green
    case "cancelled":
      return "bg-red-500";       // red
    case "refunded":
      return "bg-purple-500";    // purple
    default:
      return "bg-gray-400";
  }
};

useEffect(() => {
  const handleClick = (e) => {
    if (
      !e.target.closest(".total-overlay") &&
      !e.target.closest(".total-trigger")
    ) {
      setTotalOverlay(null);
    }
  };

  if (totalOverlay) {
    document.addEventListener("mousedown", handleClick);
  }

  return () => document.removeEventListener("mousedown", handleClick);
}, [totalOverlay]);

useEffect(() => {
  const handleClick = (e) => {
    if (
      !e.target.closest(".customer-overlay") &&
      !e.target.closest(".customer-trigger")
    ) {
      setCustomerOverlay(null);
    }
  };

  if (customerOverlay) {
    document.addEventListener("mousedown", handleClick);
  }

  return () => document.removeEventListener("mousedown", handleClick);
}, [customerOverlay]);

  useEffect(() => {
  const handleClick = (e) => {
    if (!e.target.closest(".analytics-overlay") && !e.target.closest(".analytics-button")) {
      setAnalyticsOverlayOpen(false);
    }
  };

  if (analyticsOverlayOpen) {
    document.addEventListener("mousedown", handleClick);
  }

  return () => document.removeEventListener("mousedown", handleClick);
}, [analyticsOverlayOpen]);

  useEffect(() => {
  const handleClick = (e) => {
    if (!e.target.closest(".sort-overlay") && !e.target.closest(".sort-button")) {
      setSortOpen(false);
    }
  };

  if (sortOpen) {
    document.addEventListener("mousedown", handleClick);
  }

  return () => document.removeEventListener("mousedown", handleClick);
}, [sortOpen]);

    useEffect(() => {
  let mounted = true;
  setLoading(true);

  getAdminOrders()
  .then((data) => {
    if (mounted) {
      const list = Array.isArray(data?.orders) ? data.orders : [];
setOrders(list);
setTotalCount(list.length); // ✅ total count
    }
  })
    .catch(console.error)
    .finally(() => setLoading(false));

  return () => (mounted = false);
}, []);


useEffect(() => {
  const handleClick = (e) => {
    if (!e.target.closest(".actions-overlay") && !e.target.closest(".actions-button")) {
      setActionsOpen(false);
    }
  };

  if (actionsOpen) {
    document.addEventListener("mousedown", handleClick);
  }

  return () => document.removeEventListener("mousedown", handleClick);
}, [actionsOpen]);

    const filtered = orders.filter((o) => {
        const s = search.toLowerCase();

const matchesSearch =
  o.customerName.toLowerCase().includes(s) ||
  o.orderNumber.toLowerCase().includes(s) ||
  o.id.toString().includes(s) ||
  (o.customerPhone && o.customerPhone.toLowerCase().includes(s)) ||
  (o.shippingMethod && o.shippingMethod.toLowerCase().includes(s));



        const matchesStatus =
  statusFilter === "All" ? true : o.status === statusFilter;

const matchesSource =
  sourceFilter === "All" ? true : o.orderSource === sourceFilter;

const orderDate = new Date(o.date);

const matchesFrom =
  fromDate ? orderDate >= new Date(fromDate) : true;

const matchesTo =
  toDate
    ? orderDate <= new Date(toDate + "T23:59:59")
    : true;

return (
  matchesSearch &&
  matchesStatus &&
  matchesSource &&
  matchesFrom &&
  matchesTo
);


    });

    const sorted = [...filtered].sort((a, b) => {
        if (!sortBy) return 0;

        let vA = a[sortBy];
        let vB = b[sortBy];

        if (sortBy === "date") {
            vA = new Date(vA);
            vB = new Date(vB);
        }

        if (sortDirection === "asc") return vA > vB ? 1 : -1;
        return vA < vB ? 1 : -1;
    });


    const today = new Date();
today.setHours(0, 0, 0, 0);

/* ANALYTICS DATASET — INDEPENDENT FROM TABLE FILTERS */
let analyticsOrders = [];
let analyticsDays = [];

if (analyticsPeriod === "today") {

  const start = new Date();
  start.setHours(0,0,0,0);

  const end = new Date(start);
  end.setDate(end.getDate() + 1);

  analyticsOrders = orders.filter((o)=>{
    const d = new Date(o.date);
    return d >= start && d < end;
  });

  analyticsDays = [];

  for(let h = 0; h < 24; h++){

    const hourStart = new Date(start);
    hourStart.setHours(h,0,0,0);

    const hourEnd = new Date(hourStart);
    hourEnd.setHours(h+1);

    const hourOrders = analyticsOrders.filter(o=>{
      const d = new Date(o.date);
      return d >= hourStart && d < hourEnd;
    });

    analyticsDays.push({
      label: `${h}:00`,
      orders: hourOrders.length,
      revenue: hourOrders.reduce((sum,o)=>sum + o.total,0)
    });

  }

}

if (analyticsPeriod === "7") {
  const start = new Date();
  start.setDate(start.getDate() - 6);
  start.setHours(0, 0, 0, 0);

  analyticsOrders = orders.filter((o) => {
    const d = new Date(o.date);
    return d >= start;
  });

  analyticsDays = [];

  for (let i = 6; i >= 0; i--) {
    const d = new Date();
    d.setDate(d.getDate() - i);
    d.setHours(0, 0, 0, 0);

    const next = new Date(d);
    next.setDate(next.getDate() + 1);

    const dayOrders = orders.filter((o) => {
      const od = new Date(o.date);
      return od >= d && od < next;
    });

    analyticsDays.push({
      label: d.toLocaleDateString(),
      orders: dayOrders.length,
      revenue: dayOrders.reduce((sum, o) => sum + o.total, 0),
    });
  }
}

if (analyticsPeriod === "30") {
  const start = new Date();
  start.setDate(start.getDate() - 29);
  start.setHours(0, 0, 0, 0);

  analyticsOrders = orders.filter((o) => {
    const d = new Date(o.date);
    return d >= start;
  });

  analyticsDays = [];

  for (let i = 29; i >= 0; i--) {
    const d = new Date();
    d.setDate(d.getDate() - i);
    d.setHours(0, 0, 0, 0);

    const next = new Date(d);
    next.setDate(next.getDate() + 1);

    const dayOrders = orders.filter((o) => {
      const od = new Date(o.date);
      return od >= d && od < next;
    });

    analyticsDays.push({
      label: d.toLocaleDateString(),
      orders: dayOrders.length,
      revenue: dayOrders.reduce((sum, o) => sum + o.total, 0),
    });
  }
}

const analyticsTotalRevenue = analyticsOrders.reduce((sum, o) => sum + o.total, 0);

const analyticsAvgOrder =
  analyticsOrders.length > 0 ? analyticsTotalRevenue / analyticsOrders.length : 0;

const analyticsPendingOrders = analyticsOrders.filter(
  (o) => o.status === "pending"
).length;

const analyticsDeliveredOrders = analyticsOrders.filter(
  (o) => o.status === "delivered"
).length;

const analyticsCancelledOrders = analyticsOrders.filter(
  (o) => o.status === "cancelled"
).length;

const analyticsPaidOrders = analyticsOrders.filter(
  (o) => o.status === "paid"
).length;

const ordersTrend = analyticsDays.map((d) => d.orders);
const revenueTrend = analyticsDays.map((d) => d.revenue);
const ordersTrendLabels = analyticsDays.map((d) => d.label);
const revenueTrendLabels = analyticsDays.map((d) => d.label);

    const changeSort = (field) => {
        if (sortBy === field) {
            setSortDirection(sortDirection === "asc" ? "desc" : "asc");
        } else {
            setSortBy(field);
            setSortDirection("asc");
        }
    };

    const getSortIcon = (field) => {
        if (sortBy !== field) return <FaSort className="inline ml-1 opacity-40" />;
        return sortDirection === "asc" ? (
            <FaSortUp className="inline ml-1" />
        ) : (
            <FaSortDown className="inline ml-1" />
        );
    };

    const totalPages = Math.max(1, Math.ceil(sorted.length / rowsPerPage));

const paginatedOrders = sorted.slice(
  (currentPage - 1) * rowsPerPage,
  currentPage * rowsPerPage
);

    const confirmDelete = async () => {
  try {
    await deleteAdminOrder(deleteId);
    setOrders((prev) => prev.filter((o) => o.id !== deleteId));
    setTotalCount((c) => c - 1);

    // ✅ show toast
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  } catch (e) {
    alert(e.message);
  } finally {
    setDeleteId(null);
  }
};

const confirmBulkDelete = async () => {
  try {
    await Promise.all(
      selectedOrders.map((id) => deleteAdminOrder(id))
    );

    setOrders((prev) =>
      prev.filter((o) => !selectedOrders.includes(o.id))
    );

    setSelectedOrders([]);

    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);

  } catch (e) {
    alert(e.message);
  } finally {
    setDeleteId(null);
  }
};

const toggleOrderSelection = (id) => {
  setSelectedOrders((prev) =>
    prev.includes(id)
      ? prev.filter((o) => o !== id)
      : [...prev, id]
  );
};

const toggleSelectAll = () => {
  if (selectedOrders.length === paginatedOrders.length) {
    setSelectedOrders([]);
  } else {
    setSelectedOrders(paginatedOrders.map((o) => o.id));
  }
};

const resetFilters = () => {
  setSearch("");
  setStatusFilter("All");
  setSourceFilter("All");
  setFromDate("");
  setToDate("");
};

const getAscendingLabel = (field)=>{
if(field==="date") return TEXT.oldestToNewest;
if(field==="total") return TEXT.lowestToHighest;
if(["customerName","status","orderSource"].includes(field)) return TEXT.az;
return TEXT.ascending;
};

const getDescendingLabel = (field)=>{
if(field==="date") return TEXT.newestToOldest;
if(field==="total") return TEXT.highestToLowest;
if(["customerName","status","orderSource"].includes(field)) return TEXT.za;
return TEXT.descending;
};

useEffect(() => {
  if (!didMountOrderFiltersRef.current) {
    didMountOrderFiltersRef.current = true;
    return;
  }

  goToOrdersPage(1);
}, [search, statusFilter, sourceFilter, fromDate, toDate]);

const formatLocalDateInput = (date) => {
  if (!date) return "";

  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");

  return `${y}-${m}-${d}`;
};

const parseLocalDateInput = (value) => {
  if (!value) return null;

  const [y, m, d] = value.split("-").map(Number);
  return new Date(y, m - 1, d);
};

const openCustomDateModal = () => {
  const start = parseLocalDateInput(fromDate);
  const end = parseLocalDateInput(toDate);

  const base = end || start || new Date();

  setCustomRangeStart(start);
  setCustomRangeEnd(end);
  setCustomCalendarBaseDate(base);
  setCustomCalendarOffset(0);
  setDateOverlayOpen(true);
};

const getCustomRangeLabel = () => {
  if (!customRangeStart && !customRangeEnd) {
    return lang === "EN"
      ? "Select start and end date"
      : "اختر تاريخ البداية والنهاية";
  }

  const format = (date) =>
    date.toLocaleDateString(lang === "AR" ? "ar" : "en", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });

  if (customRangeStart && !customRangeEnd) {
    return `${format(customRangeStart)} → ${
      lang === "EN" ? "Select end date" : "اختر تاريخ النهاية"
    }`;
  }

  return `${format(customRangeStart)} → ${format(customRangeEnd)}`;
};

const hasCustomDate = Boolean(fromDate || toDate);

const OrdersDateRangeCalendar = () => {
  const base = new Date(
    customCalendarBaseDate.getFullYear(),
    customCalendarBaseDate.getMonth() + customCalendarOffset,
    1
  );

  const year = base.getFullYear();
  const month = base.getMonth();

  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const days = [];

  for (let i = 0; i < firstDay; i++) {
    days.push(null);
  }

  for (let i = 1; i <= daysInMonth; i++) {
    days.push(i);
  }

  const monthLabel = base.toLocaleDateString(lang === "AR" ? "ar" : "en", {
    month: "long",
    year: "numeric",
  });

  const rangeStart =
    customRangeStart && customRangeEnd && customRangeStart > customRangeEnd
      ? customRangeEnd
      : customRangeStart;

  const rangeEnd =
    customRangeStart && customRangeEnd && customRangeStart > customRangeEnd
      ? customRangeStart
      : customRangeEnd;

  return (
    <div className="w-full">
      {/* MONTH HEADER */}
      <div className="flex items-center justify-between mb-4">
        <button
          type="button"
          onClick={() => setCustomCalendarOffset((v) => v - 1)}
          className="w-8 h-8 rounded-lg border border-gray-200 bg-white hover:bg-gray-100 transition text-sm font-semibold"
        >
          {lang === "AR" ? "›" : "‹"}
        </button>

        <div className="text-sm font-semibold text-gray-900">
          {monthLabel}
        </div>

        <button
          type="button"
          onClick={() => setCustomCalendarOffset((v) => v + 1)}
          className="w-8 h-8 rounded-lg border border-gray-200 bg-white hover:bg-gray-100 transition text-sm font-semibold"
        >
          {lang === "AR" ? "‹" : "›"}
        </button>
      </div>

      {/* DAYS LABELS */}
      <div className="grid grid-cols-7 text-xs text-gray-500 mb-1">
        {(lang === "AR"
          ? ["ح", "ن", "ث", "ر", "خ", "ج", "س"]
          : ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
        ).map((d) => (
          <div key={d} className="text-center">
            {d}
          </div>
        ))}
      </div>

      {/* DAYS GRID */}
      <div className="grid grid-cols-7 gap-y-1 text-sm">
        {days.map((d, i) => {
          const currentDate = d ? new Date(year, month, d) : null;

          const todayDate = new Date();
          todayDate.setHours(0, 0, 0, 0);

          const isToday =
            currentDate &&
            currentDate.toDateString() === todayDate.toDateString();

          const isRangeStart =
            currentDate &&
            customRangeStart &&
            currentDate.toDateString() === customRangeStart.toDateString();

          const isRangeEnd =
            currentDate &&
            customRangeEnd &&
            currentDate.toDateString() === customRangeEnd.toDateString();

          const isInRange =
            currentDate &&
            rangeStart &&
            rangeEnd &&
            currentDate > rangeStart &&
            currentDate < rangeEnd;

          return (
            <button
              type="button"
              key={i}
              disabled={!d}
              onClick={() => {
                if (!d) return;

                const clicked = new Date(year, month, d);

                // First click OR after completed range: start new range
                if (!customRangeStart || (customRangeStart && customRangeEnd)) {
                  setCustomRangeStart(clicked);
                  setCustomRangeEnd(null);
                  return;
                }

                // Second click: complete range
                if (clicked < customRangeStart) {
                  setCustomRangeStart(clicked);
                  setCustomRangeEnd(customRangeStart);
                } else {
                  setCustomRangeEnd(clicked);
                }
              }}
              className={`
                h-8 w-8 mx-auto
                flex items-center justify-center
                rounded-md
                text-[13px]
                transition
                ${!d ? "cursor-default" : "hover:bg-gray-200"}
                ${isInRange ? "bg-gray-200" : ""}
                ${isRangeStart || isRangeEnd ? "bg-black text-white" : ""}
              `}
            >
              <span className="relative flex items-center justify-center w-full h-full">
                {d}

                {isToday && !isRangeStart && !isRangeEnd && (
                  <span className="absolute bottom-1 w-1 h-1 bg-black rounded-full"></span>
                )}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

const getTrend = (data = []) => {

if(data.length < 2) return null;

const last = data[data.length - 1];
const prev = data[data.length - 2];

if(last > prev){
return <span className="text-green-600 text-xs ml-1">↑</span>;
}

if(last < prev){
return <span className="text-red-500 text-xs ml-1">↓</span>;
}

return <span className="text-gray-400 text-xs ml-1">→</span>;

};

const useCountUp = (value, duration = 600) => {

const [display, setDisplay] = useState(0);

useEffect(()=>{

let start = 0;
const step = value / (duration / 16);

const timer = setInterval(()=>{

start += step;

if(start >= value){
start = value;
clearInterval(timer);
}

setDisplay(Math.floor(start));

},16);

return ()=>clearInterval(timer);

},[value]);

return display;

};

const AnalyticsHoverInfo = ({ text, children }) => {
  return (
    <div className="relative group">
      <div
        className="
        pointer-events-none
        absolute
        left-1/2
        bottom-full
        mb-2
        -translate-x-1/2
        w-[220px]
        opacity-0
        translate-y-1
        group-hover:opacity-100
        group-hover:translate-y-0
        transition-all duration-200
        z-40
        "
      >
        <div
          className="
          relative
          rounded-[12px]
          border border-[#d9d9d9]
          bg-white
          px-3 py-2
          text-[12px]
          leading-5
          text-gray-900
          shadow-[0_10px_30px_rgba(0,0,0,0.12)]
          "
        >
          {text}

          <div
            className="
            absolute
            left-1/2
            top-full
            -translate-x-1/2
            w-3 h-3
            bg-white
            border-r border-b border-[#d9d9d9]
            rotate-45
            -mt-[6px]
            "
          />
        </div>
      </div>

      {children}
    </div>
  );
};

const MiniChart = ({ data = [], labels = [], type = "orders" }) => {

  const [tooltip, setTooltip] = useState(null);

  const width = 120;
  const height = 26;

  if (!data.length) return null;

  const max = Math.max(...data, 1);
  const min = Math.min(...data, 0);

  const points = data.map((v, i) => {
    const x = (i / (data.length - 1 || 1)) * width;
    const y = height - ((v - min) / (max - min || 1)) * height;
    return { x, y, v, label: labels[i] };
  });

  const path = points
    .map((p, i) => `${i === 0 ? "M" : "L"} ${p.x} ${p.y}`)
    .join(" ");

  return (
    <div className="relative w-[120px] h-[28px] group">

      <svg
        width={width}
        height={height}
        className="overflow-visible"
      >

{/* crosshair */}
{tooltip && (
<line
x1={tooltip.x}
y1="0"
x2={tooltip.x}
y2={height}
stroke="#9ca3af"
strokeWidth="1"
strokeDasharray="2,2"
/>
)}
        {/* grid baseline */}
        <line
          x1="0"
          y1={height}
          x2={width}
          y2={height}
          stroke="#e5e7eb"
          strokeWidth="1"
        />

        {/* chart line */}
        <path
          d={path}
          fill="none"
          stroke="#3b82f6"
          strokeWidth="2"
          className="animate-chartLine"
        />

        {/* points */}
        {points.map((p, i) => (
          <circle
            key={i}
            cx={p.x}
            cy={p.y}
            r="2.5"
            fill="#3b82f6"
            className="cursor-pointer hover:r-[4]"
            onMouseEnter={(e) => {
              setTooltip({
                x: p.x,
                y: p.y,
                label: p.label,
                value: p.v
              });
            }}
            onMouseLeave={() => setTooltip(null)}
          />
        ))}

      </svg>

      {/* tooltip */}
      {tooltip && (
        <div
          className="
          absolute
          px-2 py-1
          text-[11px]
          bg-gray-900
          text-white
          rounded
          shadow
          pointer-events-none
          whitespace-nowrap
          z-50
          "
          style={{
            left: tooltip.x - 10,
            top: tooltip.y - 30
          }}
        >
          {tooltip.label} • {type === "revenue"
            ? `$${tooltip.value.toFixed(2)}`
            : tooltip.value}
        </div>
      )}

    </div>
  );
};

const OrdersTableSkeleton = () => (
  <>
    {Array.from({ length: 8 }).map((_, i) => (
      <tr key={i} className="border-b border-[#f1f1f1] animate-pulse">
        <td className="px-3 py-3">
          <div className="w-4 h-4 bg-gray-200 rounded" />
        </td>
        <td className="px-4 py-3">
          <div className="w-24 h-4 bg-gray-200 rounded" />
        </td>
        <td className="px-4 py-3">
          <div className="w-32 h-4 bg-gray-200 rounded" />
        </td>
        <td className="px-4 py-3">
          <div className="w-20 h-4 bg-gray-200 rounded" />
        </td>
        <td className="px-4 py-3">
          <div className="w-24 h-5 bg-gray-200 rounded-md" />
        </td>
        <td className="px-4 py-3">
          <div className="w-24 h-4 bg-gray-200 rounded" />
        </td>
        <td className="px-3 py-3">
          <div className="w-20 h-5 bg-gray-200 rounded-md mx-auto" />
        </td>
        <td className="px-4 py-3">
          <div className="w-5 h-5 bg-gray-200 rounded-full mx-auto" />
        </td>
      </tr>
    ))}
  </>
);

const MobileOrderSkeleton = () => (
  <div className="md:hidden space-y-4">
    {Array.from({ length: 4 }).map((_, i) => (
      <div
        key={i}
        className="bg-white border border-[#e3e3e3] rounded-none p-4 -mx-4 animate-pulse"
      >
        <div className="flex justify-between mb-4">
          <div className="w-28 h-4 bg-gray-200 rounded" />
          <div className="w-20 h-4 bg-gray-200 rounded" />
        </div>

        <div className="space-y-3">
          <div className="w-32 h-4 bg-gray-200 rounded" />
          <div className="w-44 h-4 bg-gray-200 rounded" />
          <div className="w-24 h-5 bg-gray-200 rounded-md" />
          <div className="w-36 h-4 bg-gray-200 rounded" />
        </div>

        <div className="flex justify-end gap-4 mt-4 pt-3 border-t">
          <div className="w-5 h-5 bg-gray-200 rounded" />
          <div className="w-5 h-5 bg-gray-200 rounded" />
        </div>
      </div>
    ))}
  </div>
);

const EmptyOrdersState = () => (
  <div className="text-center py-12 px-4">
    <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-gray-100 flex items-center justify-center">
      <FaInbox className="text-gray-400 text-xl" />
    </div>

    <h3 className="text-sm font-semibold text-gray-800">
      {TEXT.emptyTitle}
    </h3>

    <p className="text-sm text-gray-500 mt-1">
      {TEXT.emptyDesc}
    </p>

    {(search || statusFilter !== "All" || sourceFilter !== "All" || fromDate || toDate) && (
      <button
        onClick={resetFilters}
        className="mt-4 h-8 px-3 rounded-lg border border-gray-300 bg-white text-sm font-medium text-gray-900 hover:bg-gray-50"
      >
        {TEXT.clearFilters}
      </button>
    )}
  </div>
);

 const animatedOrders = useCountUp(analyticsOrders.length);
    const animatedRevenue = useCountUp(analyticsTotalRevenue);
    const animatedAvg = useCountUp(analyticsAvgOrder);
    
    return (
    <div className={`flex bg-[#f1f1f1] min-h-screen ${isOpen ? "overflow-hidden" : ""}`}>
      <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />

            <div className={`flex-1 ${lang === "EN" ? "lg:ml-64" : ""} w-full transition-all duration-300`}>
                <AdminHeader setIsOpen={setIsOpen} />

                <main className="p-4 sm:p-6 animate-fadeSlide">

                   {/* PAGE HEADER (SHOPIFY STYLE) */}
<div className="flex items-center justify-between mb-5">

{/* LEFT SIDE */}
<div className="mx-1 flex items-center gap-2">

<div className="flex items-center justify-center w-6 h-6">
<FaInbox className="text-[18px] text-gray-900" />
</div>

<div className="flex items-baseline gap-2">
<h1 className="text-[20px] font-semibold text-gray-900">
{TEXT.title}
</h1>
</div>

</div>


{/* RIGHT SIDE */}
<div className="flex items-center gap-2">

{/* MORE ACTIONS */}
<div className="relative">

<button
onClick={() => setActionsOpen((v)=>!v)}
className="
actions-button
flex items-center gap-1
h-8 px-3
bg-[#f6f6f7]
border border-gray-300
rounded-lg
shadow-[0_1px_0_rgba(0,0,0,0.04),0_2px_5px_rgba(0,0,0,0.06)]
text-sm font-medium text-gray-900
hover:bg-gray-100
active:shadow-[inset_0_2px_4px_rgba(0,0,0,0.12)]
transition
"
>
{TEXT.actions}
<FiChevronDown className="text-gray-500 text-sm"/>
</button>

{actionsOpen && (
<div className="
actions-overlay
absolute right-0 top-full mt-0.5
w-48
bg-white
border border-gray-300
rounded-xl
shadow-[0_20px_40px_rgba(0,0,0,0.12)]
z-50
animate-sortOverlay
">

<button
onClick={()=>{
setAnalyticsOpen(v=>!v);
setActionsOpen(false);
}}
className="
flex items-center gap-2
w-full
px-3 py-2
text-sm
text-gray-900
hover:bg-gray-100
transition
"
>
<FaEye className="text-gray-600"/>
{analyticsOpen ? TEXT.hideAnalytics : TEXT.showAnalytics}
</button>

</div>
)}

</div>

{/* CREATE ORDER */}
<button
onClick={() => navigate("/admin/orders/add")}
className="
h-8 px-3
bg-[#1f1f1f]
text-white
rounded-lg
shadow-[0_1px_0_rgba(0,0,0,0.08),0_3px_8px_rgba(0,0,0,0.2)]
text-sm font-medium
hover:bg-black
active:shadow-[inset_0_2px_6px_rgba(0,0,0,0.3)]
transition
"
>
{TEXT.createOrder}
</button>

</div>

</div>

{analyticsOpen && (
  <div className="md:hidden mb-5 -mx-4 md:mx-0">
    <div className="bg-white border border-[#e3e3e3] rounded-none md:rounded-[12px] shadow-[0_1px_0_rgba(0,0,0,0.04)] overflow-hidden">
      
      {/* MOBILE ANALYTICS HEADER */}
      <div className="px-4 py-2.5 border-b border-[#e3e3e3] flex items-center justify-between">
        <button
          onClick={() => setAnalyticsOverlayOpen((v) => !v)}
          className="
          analytics-button
          flex items-center gap-2
          px-3 py-1.5
          bg-[#f6f6f7]
          border border-gray-300
          rounded-lg
          text-sm font-medium text-gray-900
          hover:bg-gray-100
          transition
          "
        >
          <FaBoxOpen className={`text-gray-600 text-sm transition ${analyticsOverlayOpen ? "rotate-12" : ""}`} />
          {analyticsPeriod === "today" && TEXT.today}
          {analyticsPeriod === "7" && TEXT.last7Days}
          {analyticsPeriod === "30" && TEXT.last30Days}
        </button>

        <div className="text-xs text-gray-500">
          {analyticsOrders.length} {TEXT.orders}
        </div>
      </div>

      {/* MOBILE ANALYTICS CARDS */}
      <div className="p-4 grid grid-cols-2 gap-2">

        <div className="rounded-[12px] border border-gray-200 bg-[#fcfcfc] p-2.5">
          <div className="text-xs text-gray-500 mb-0.5">{TEXT.orders}</div>
          <div className="text-[17px] font-semibold text-gray-900">
            {loading ? <div className="w-10 h-5 bg-gray-200 rounded animate-pulse" /> : animatedOrders}
          </div>
          <div className="mt-1">
            <MiniChart data={ordersTrend} labels={ordersTrendLabels} type="orders" />
          </div>
        </div>

        <div className="rounded-[12px] border border-gray-200 bg-[#fcfcfc] p-2.5">
          <div className="text-xs text-gray-500 mb-0.5">{TEXT.revenue}</div>
          <div className="text-[17px] font-semibold text-gray-900">
            {loading ? <div className="w-14 h-5 bg-gray-200 rounded animate-pulse" /> : `$${animatedRevenue.toFixed(0)}`}
          </div>
          <div className="mt-1">
            <MiniChart data={revenueTrend} labels={revenueTrendLabels} type="revenue" />
          </div>
        </div>

        <div className="rounded-[12px] border border-gray-200 bg-[#fcfcfc] p-2.5">
          <div className="text-xs text-gray-500 mb-0.5">{TEXT.avgOrder}</div>
          <div className="text-[17px] font-semibold text-gray-900">
            {loading ? <div className="w-14 h-5 bg-gray-200 rounded animate-pulse" /> : `$${animatedAvg.toFixed(0)}`}
          </div>
        </div>

        <div className="rounded-[12px] border border-gray-200 bg-[#fcfcfc] p-2.5">
          <div className="text-xs text-gray-500 mb-0.5">{TEXT.pending}</div>
          <div className="text-[17px] font-semibold text-amber-600">
            {loading ? <div className="w-8 h-5 bg-gray-200 rounded animate-pulse" /> : analyticsPendingOrders}
          </div>
        </div>

        <div className="rounded-[12px] border border-gray-200 bg-[#fcfcfc] p-2.5">
          <div className="text-xs text-gray-500 mb-0.5">{TEXT.deliveredLabel}</div>
          <div className="text-[17px] font-semibold text-green-600">
            {loading ? <div className="w-8 h-5 bg-gray-200 rounded animate-pulse" /> : analyticsDeliveredOrders}
          </div>
        </div>

        <div className="rounded-[12px] border border-gray-200 bg-[#fcfcfc] p-2.5">
          <div className="text-xs text-gray-500 mb-0.5">{TEXT.cancelledLabel}</div>
          <div className="text-[17px] font-semibold text-red-600">
            {loading ? <div className="w-8 h-5 bg-gray-200 rounded animate-pulse" /> : analyticsCancelledOrders}
          </div>
        </div>

<div className="rounded-[12px] border border-gray-200 bg-[#fcfcfc] p-2.5">
  <div className="text-xs text-gray-500 mb-0.5">{TEXT.paidLabel}</div>
  <div className="text-[17px] font-semibold text-emerald-600">
    {loading ? <div className="w-8 h-5 bg-gray-200 rounded animate-pulse" /> : analyticsPaidOrders}
  </div>
</div>

      </div>
    </div>
  </div>
)}

{/* MOBILE FILTER HEADER */}
<div className="md:hidden mb-4">

  <div className="bg-white border border-gray-200 rounded-none md:rounded-xl shadow-sm p-3 space-y-3 -mx-4 md:mx-0">

    {/* STATUS FILTERS */}
    <div className="flex gap-2 overflow-x-auto pb-1">

      {["All","pending","paid","shipped","delivered","cancelled","refunded"].map((s)=>{

        const active = statusFilter === s;

        const label =
        s === "All" ? TEXT.all :
        s === "pending" ? TEXT.pending :
        s === "paid" ? TEXT.paid :
        s === "shipped" ? TEXT.shipped :
        s === "delivered" ? TEXT.delivered :
        s === "cancelled" ? TEXT.cancelled :
        s === "refunded" ? TEXT.refunded :
        s;

        return (
          <button
            key={s}
            onClick={()=>setStatusFilter(s)}
            className={`
              whitespace-nowrap
              px-3 py-[6px]
              text-[13px] font-medium
              rounded-md
              border
              transition
              ${active
                ? "bg-gray-900 text-white border-gray-900"
                : "bg-gray-100 text-gray-900 border-gray-200"}
            `}
          >
            {label}
          </button>
        );

      })}

    </div>


    {/* SEARCH + SORT */}
    <div className="flex items-center gap-2">

      {/* SEARCH */}
{!searchOpen ? (
  <button
    onClick={() => setSearchOpen(true)}
    className="
    flex items-center justify-center
    flex-1
    h-9
    bg-white
    border border-gray-300
    rounded-lg
    shadow-sm
    hover:bg-gray-50
    transition
    "
  >
    <FaSearch className="text-gray-600 text-sm" />
  </button>
) : (

  <div className="flex items-center gap-2 flex-1">

    <div className="
      flex items-center gap-2
      flex-1
      h-9
      px-3
      bg-white
      border border-gray-300
      rounded-lg
      shadow-sm
    ">

      <FaSearch className="text-gray-400 text-sm"/>

      <input
        autoFocus
        type="text"
        value={search}
        onChange={(e)=>setSearch(e.target.value)}
        placeholder={TEXT.searchPlaceholder}
        className="flex-1 outline-none text-sm"
      />

      <button
        onClick={()=>{
          setSearch("");
          setSearchOpen(false);
        }}
        className="text-gray-400 text-sm"
      >
        ✕
      </button>

    </div>

  </div>

)}

      {/* SORT */}
      <button
        onClick={() => setSortOpen((v)=>!v)}
        className="
        flex items-center justify-center
        flex-1
        h-9
        bg-white
        border border-gray-300
        rounded-lg
        shadow-sm
        hover:bg-gray-50
        transition
        "
      >
        <span className="text-gray-600 text-sm">⇅</span>
      </button>

    </div>

  </div>

{/* MOBILE SORT OVERLAY */}
{sortOpen && (
<>

{/* BACKDROP */}
<div
className="fixed inset-0 bg-black/30 md:hidden z-40"
onClick={()=>setSortOpen(false)}
/>

{/* OVERLAY PANEL */}
<div className="
sort-overlay
md:hidden
fixed
left-4
right-4
top-[210px]
bg-white
border border-gray-200
rounded-xl
shadow-[0_30px_40px_rgba(0,0,0,0.18)]
z-50
animate-sortOverlay
">

{/* SECTION 1 */}
<div className="px-4 pt-4 text-xs font-semibold uppercase tracking-wide">
{TEXT.sortBy}
</div>

{/* SECTION 2 */}
<div className="mt-1 text-sm">

{[
{label: TEXT.orderNumber, value:"orderNumber"},
{label: TEXT.date, value:"date"},
{label: TEXT.customerName, value:"customerName"},
{label: TEXT.orderStatus, value:"status"},
{label: TEXT.totalLabel, value:"total"},
{label: TEXT.sourceLabel, value:"orderSource"},
].map(opt=>(

<label
key={opt.value}
className={`
flex items-center gap-3
px-3 py-2
cursor-pointer
rounded-md
transition
hover:bg-gray-100
${sortField === opt.value ? "bg-gray-100 font-medium" : ""}
`}
>

<input
type="radio"
name="sortFieldMobile"
checked={sortField===opt.value}
onChange={()=>setSortField(opt.value)}
className="w-4 h-4 accent-gray-800 cursor-pointer"
/>

{opt.label}

</label>

))}

</div>

<div className="my-2 border-t border-gray-300"></div>

{/* SECTION 3 */}
<div className="px-1 pb-1 flex flex-col">

<button
onClick={()=>{
setSortBy(sortField);
setSortDirection("asc");
setSortOpen(false);
}}
className="
flex items-center gap-2
px-3 py-2
text-sm
rounded-md
hover:bg-gray-100
transition
"
>
↑ {getAscendingLabel(sortField)}
</button>

<button
onClick={()=>{
setSortBy(sortField);
setSortDirection("desc");
setSortOpen(false);
}}
className="
flex items-center gap-2
px-3 py-2
text-sm
rounded-md
hover:bg-gray-100
transition
"
>
↓ {getDescendingLabel(sortField)}
</button>

{/* SOURCE FILTER */}
{sortField === "orderSource" && (
<>
<div className="my-2 border-t border-gray-300"></div>

<div className="px-3 pb-2 flex items-center justify-between">

<button
onClick={()=>{ setSourceFilter("website"); setSortOpen(false); }}
className={`p-2 rounded-md hover:bg-gray-100 transition ${
sourceFilter==="website" ? "bg-gray-100" : ""
}`}
>
<FaGlobe className="text-gray-600"/>
</button>

<button
onClick={()=>{ setSourceFilter("whatsapp"); setSortOpen(false); }}
className={`p-2 rounded-md hover:bg-gray-100 transition ${
sourceFilter==="whatsapp" ? "bg-gray-100" : ""
}`}
>
<FaWhatsapp className="text-gray-600"/>
</button>

<button
onClick={()=>{ setSourceFilter("store"); setSortOpen(false); }}
className={`p-2 rounded-md hover:bg-gray-100 transition ${
sourceFilter==="store" ? "bg-gray-100" : ""
}`}
>
<FaStore className="text-gray-600"/>
</button>

</div>

<button
onClick={()=>{ setSourceFilter("All"); setSortOpen(false); }}
className="mx-3 mb-2 px-3 py-1 text-xs rounded-md bg-gray-100 hover:bg-gray-200 transition"
>
{TEXT.clearSourceFilter}
</button>
</>
)}

{/* DATE OPTIONS */}
{sortField === "date" && (
hasCustomDate ? (
<button
onClick={()=>{
setFromDate("");
setToDate("");
setDateOverlayOpen(false);
setSortOpen(false);
}}
className="
flex items-center gap-2
px-3 py-2
text-sm
rounded-md
hover:bg-gray-100
transition
"
>
↺ {TEXT.resetDate}
</button>
) : (
<button
onClick={() => {
  openCustomDateModal();
  setSortOpen(false);
}}
className="
flex items-center gap-2
px-3 py-2
text-sm
rounded-md
hover:bg-gray-100
transition
"
>
<FaRegCalendarAlt className="text-gray-900 text-sm" />
{TEXT.customDate}
</button>
)
)}

</div>

</div>
</>
)}

</div>

                    {/* MOBILE CARDS */}
<div className="md:hidden space-y-4">
  {loading ? (
    <MobileOrderSkeleton />
  ) : sorted.length === 0 ? (
    <div className="bg-white border border-[#e3e3e3] rounded-none -mx-4">
      <EmptyOrdersState />
    </div>
  ) : (
    paginatedOrders.map((o) => (
      <div
  key={o.id}
  className="
bg-white
border border-[#e3e3e3]
rounded-none md:rounded-xl
shadow-[0_1px_0_rgba(0,0,0,0.04)]
p-4
-mx-4 md:mx-0
"
>
        <div className="flex justify-between items-start mb-3">
          <span className="font-semibold text-gray-900">
  #{o.id} <span className="text-gray-400 text-[12px]">({o.orderNumber})</span>
</span>

          <span className="text-sm text-gray-500">
            {formatDate(o.date)}
          </span>
        </div>
        <div className="flex items-center gap-2 mt-1 text-sm">
  <span className="text-gray-500">{TEXT.source}:</span>
  {orderSourceIcon(o.orderSource)}
</div>


        <p className="text-sm">
  <b>{TEXT.customer}:</b> {o.customerName}
  {o.customerPhone && ` • ${o.customerPhone}`}
</p>


        <p className="text-sm">
  <span className="text-gray-500">{TEXT.total}:</span>

  <span className="block">

    {/* Subtotal */}
    {(o.subtotal ?? (o.total + (o.discount || 0) - (o.extraFeeAmount || 0))) !== o.total && (
      <span className="block text-xs text-gray-400">
        ${(o.subtotal ?? (o.total + (o.discount || 0) - (o.extraFeeAmount || 0))).toFixed(2)}
      </span>
    )}

    {/* Discount */}
    {o.discount > 0 && (
      <span className="block text-xs text-red-600">
        - ${o.discount.toFixed(2)} {lang === "EN" ? "discount" : "خصم"}
      </span>
    )}

    {/* Extra Fee */}
    {o.extraFeeAmount > 0 && (
      <span className="block text-xs text-green-600">
        + {o.extraFeeLabel || TEXT.extraFee} ${o.extraFeeAmount.toFixed(2)}
      </span>
    )}

    {/* Final Total */}
    <span className="block font-semibold text-gray-900">
      ${o.total.toFixed(2)}
    </span>

  </span>
</p>


        <span
className={`inline-flex items-center gap-1.5 px-2.5 py-[2px] rounded-md text-[12px] font-medium ${statusColor(o.status)}`}
>
<span className={`w-1.5 h-1.5 rounded-full ${statusDotColor(o.status)}`}></span>
{
o.status === "pending" ? TEXT.pending :
o.status === "paid" ? TEXT.paid :
o.status === "shipped" ? TEXT.shipped :
o.status === "delivered" ? TEXT.delivered :
o.status === "cancelled" ? TEXT.cancelled :
o.status === "refunded" ? TEXT.refunded :
o.status
}
</span>

<div className="flex items-center gap-2 mt-1 text-sm">
  <span className="text-gray-500">
    {lang === "EN" ? "Shipping:" : "الشحن:"}
  </span>
  <span
    className={`font-semibold
      ${o.shippingMethod === "pickup"
        ? "text-green-600"
        : "text-blue-600"}
    `}
  >
    {o.shippingMethod === "pickup"
      ? lang === "EN"
        ? "Pickup"
        : "استلام"
      : lang === "EN"
      ? "Delivery"
      : "توصيل"}
  </span>
</div>


        <div className="flex justify-end gap-4 mt-3 pt-3 border-t border-gray-400">
          <button
            className="text-gray-800 hover:text-gray-800 transition"
            onClick={() => navigate(`/admin/orders/${o.id}`)}
          >
            <FaEye />
          </button>

          <button
            className="text-gray-800 hover:text-red-600 transition"
            onClick={() => setDeleteId(o.id)}
          >
            <FaTrash />
          </button>
        </div>
      </div>
    ))
  )}
  {sorted.length > 0 && (
  <div className="md:hidden flex items-center justify-between px-4 py-3 bg-white border-t border-gray-200 -mx-4">
    
    <button
      onClick={() => goToOrdersPage((p) => Math.max(1, p - 1))}
      disabled={currentPage === 1}
      className={`px-3 py-1.5 text-sm rounded-md border ${
        currentPage === 1
          ? "opacity-40 cursor-not-allowed"
          : "bg-gray-100"
      }`}
    >
      {TEXT.prev}
    </button>

    <span className="text-sm text-gray-600">
      {currentPage} / {totalPages}
    </span>

    <button
      onClick={() => goToOrdersPage((p) => Math.min(totalPages, p + 1))}
      disabled={currentPage === totalPages}
      className={`px-3 py-1.5 text-sm rounded-md border ${
        currentPage === totalPages
          ? "opacity-40 cursor-not-allowed"
          : "bg-gray-100"
      }`}
    >
      {TEXT.next}
    </button>

  </div>
)}
</div>

{analyticsOpen && (
<div className="
hidden md:block
mb-4
bg-white
border border-[#e3e3e3]
rounded-[12px]
shadow-[0_1px_0_rgba(0,0,0,0.04)]
">

{/* ANALYTICS GRID */}
<div className="flex items-center px-4 py-3 text-sm gap-6">

{/* Today Button */}
<button
onClick={()=>setAnalyticsOverlayOpen(v=>!v)}
className="
analytics-button
flex items-center gap-2
px-3 py-1.5
mr-4
bg-[#f6f6f7]
border border-gray-300
rounded-lg
text-sm font-medium text-gray-900
hover:bg-gray-100
transition
"
>
<FaBoxOpen className={`text-gray-600 text-sm transition ${analyticsOverlayOpen ? "rotate-12" : ""}`}/>

{analyticsPeriod === "today" && TEXT.today}
{analyticsPeriod === "7" && TEXT.last7Days}
{analyticsPeriod === "30" && TEXT.last30Days}
</button>

{/* Orders */}
<AnalyticsHoverInfo text={TEXT.ordersInfo}>
  <div className="flex items-center gap-3 px-4 border-l-2 border-gray-200 hover:bg-[#f6f6f7] rounded-[10px] transition">
    <div>
      <div className="text-xs text-gray-500">{TEXT.orders}</div>
      <div className="font-semibold text-gray-900 flex items-center">
        {loading
  ? <div className="w-10 h-5 bg-gray-200 rounded animate-pulse" />
  : animatedOrders}
        {getTrend(ordersTrend)}
      </div>
    </div>

    <MiniChart data={ordersTrend} labels={ordersTrendLabels} type="orders" />
  </div>
</AnalyticsHoverInfo>

{/* Revenue */}
<AnalyticsHoverInfo text={TEXT.revenueInfo}>
  <div className="flex items-center gap-3 px-4 border-l-2 border-gray-200 hover:bg-[#f6f6f7] rounded-[10px] transition">
    <div>
      <div className="text-xs text-gray-500">{TEXT.revenue}</div>
      <div className="font-semibold text-gray-900 flex items-center">
        {loading
  ? <div className="w-14 h-5 bg-gray-200 rounded animate-pulse" />
  : `$${animatedRevenue.toFixed(0)}`}
        {getTrend(revenueTrend)}
      </div>
    </div>

    <MiniChart data={revenueTrend} labels={revenueTrendLabels} type="revenue" />
  </div>
</AnalyticsHoverInfo>

{/* Avg */}
<AnalyticsHoverInfo text={TEXT.avgOrderInfo}>
  <div className="flex items-center gap-3 px-4 border-l-2 border-gray-200 hover:bg-[#f6f6f7] rounded-[10px] transition">
    <div>
      <div className="text-xs text-gray-500">{TEXT.avgOrder}</div>
      <div className="font-semibold text-gray-900 flex items-center">
        {loading
  ? <div className="w-14 h-5 bg-gray-200 rounded animate-pulse" />
  : `$${animatedAvg.toFixed(0)}`}
        {getTrend(revenueTrend)}
      </div>
    </div>
  </div>
</AnalyticsHoverInfo>

{/* Pending */}
<AnalyticsHoverInfo text={TEXT.pendingInfo}>
  <div className="flex items-center gap-3 px-4 border-l-2 border-gray-200 hover:bg-[#f6f6f7] rounded-[10px] transition">
    <div>
      <div className="text-xs text-gray-500">{TEXT.pending}</div>
      <div className="font-semibold text-amber-600">
        {loading
  ? <div className="w-8 h-5 bg-gray-200 rounded animate-pulse" />
  : analyticsPendingOrders}
      </div>
    </div>
  </div>
</AnalyticsHoverInfo>

{/* Delivered */}
<AnalyticsHoverInfo text={TEXT.deliveredInfo}>
  <div className="flex items-center gap-3 px-4 border-l-2 border-gray-200 hover:bg-[#f6f6f7] rounded-[10px] transition">
    <div>
      <div className="text-xs text-gray-500">{TEXT.deliveredLabel}</div>
      <div className="font-semibold text-green-600">
        {loading
  ? <div className="w-8 h-5 bg-gray-200 rounded animate-pulse" />
  : analyticsDeliveredOrders}
      </div>
    </div>
  </div>
</AnalyticsHoverInfo>

{/* Cancelled */}
<AnalyticsHoverInfo text={TEXT.cancelledInfo}>
  <div className="flex items-center gap-3 px-4 border-l-2 border-gray-200 hover:bg-[#f6f6f7] rounded-[10px] transition">
    <div>
      <div className="text-xs text-gray-500">{TEXT.cancelledLabel}</div>
      <div className="font-semibold text-red-600">
        {loading
  ? <div className="w-8 h-5 bg-gray-200 rounded animate-pulse" />
  : analyticsCancelledOrders}
      </div>
    </div>
  </div>
</AnalyticsHoverInfo>

{/* Paid */}
<AnalyticsHoverInfo text={TEXT.paidInfo}>
  <div className="flex items-center gap-3 px-4 border-l-2 border-gray-200 hover:bg-[#f6f6f7] rounded-[10px] transition">
    <div>
      <div className="text-xs text-gray-500">{TEXT.paidLabel}</div>
      <div className="font-semibold text-emerald-600">
        {loading
  ? <div className="w-8 h-5 bg-gray-200 rounded animate-pulse" />
  : analyticsPaidOrders}
      </div>
    </div>
  </div>
</AnalyticsHoverInfo>

</div>

</div>
)}

{analyticsOverlayOpen && (
<div className="
analytics-overlay
fixed md:absolute
left-6 right-6 top-[140px] md:left-auto md:right-auto md:top-auto
md:mt-[-13px]
md:w-[260px]
bg-white
border border-gray-200
rounded-xl
shadow-[0_20px_40px_rgba(0,0,0,0.15)]
z-50
p-2
">

{/* TODAY */}
<label className="flex gap-3 p-3 rounded-lg hover:bg-gray-100 cursor-pointer">

<input
type="radio"
checked={analyticsPeriod==="today"}
onChange={()=>{
setAnalyticsPeriod("today");
setAnalyticsOverlayOpen(false);
}}
className="w-4 h-4 mt-1 accent-gray-800 cursor-pointer"
/>

<div>
<div className="font-medium text-sm">{TEXT.today}</div>
<div className="text-xs text-gray-500">
{TEXT.todayAnalytics}
</div>
</div>

</label>

{/* 7 DAYS */}
<label className="flex gap-3 p-3 rounded-lg hover:bg-gray-100 cursor-pointer">

<input
type="radio"
checked={analyticsPeriod==="7"}
onChange={()=>{
setAnalyticsPeriod("7");
setAnalyticsOverlayOpen(false);
}}
className="w-4 h-4 mt-1 accent-gray-800 cursor-pointer"
/>

<div>
<div className="font-medium text-sm">{TEXT.last7Days}</div>
<div className="text-xs text-gray-500">
{TEXT.weekAnalytics}
</div>
</div>

</label>

{/* 30 DAYS */}
<label className="flex gap-3 p-3 rounded-lg hover:bg-gray-100 cursor-pointer">

<input
type="radio"
checked={analyticsPeriod==="30"}
onChange={()=>{
setAnalyticsPeriod("30");
setAnalyticsOverlayOpen(false);
}}
className="w-4 h-4 mt-1 accent-gray-800 cursor-pointer"
/>

<div>
<div className="font-medium text-sm">{TEXT.last30Days}</div>
<div className="text-xs text-gray-500">
{TEXT.monthAnalytics}
</div>
</div>

</label>

</div>
)}

{/* DESKTOP TABLE */}
<div className="
hidden md:block
bg-white
border border-[#e3e3e3]
rounded-[14px]
overflow-visible
shadow-[0_12px_32px_rgba(0,0,0,0.10),0_2px_6px_rgba(0,0,0,0.06)]
">

{/* TABLE TOP HEADER */}
<div className="relative flex items-center justify-between px-4 py-3 border-b border-[#e3e3e3] bg-white rounded-t-[14px] overflow-visible">

{sortOpen && (
<div
  className={`
    sort-overlay
    absolute
    ${lang === "AR" ? "left-3" : "right-3"}
    top-full
    w-47
    bg-white
    border border-gray-200
    rounded-xl
    shadow-[0_30px_30px_rgba(0,0,0,0.15)]
    z-50
    animate-sortOverlay
  `}
>

{/* SECTION 1 */}
<div className="px-4 pt-4 text-xs font-semibold uppercase tracking-wide">
{TEXT.sortBy}
</div>

{/* SECTION 2 */}
<div className="mt-1 text-sm">

{[
{label: TEXT.orderNumber, value:"orderNumber"},
{label: TEXT.date, value:"date"},
{label: TEXT.customerName, value:"customerName"},
{label: TEXT.orderStatus, value:"status"},
{label: TEXT.totalLabel, value:"total"},
{label: TEXT.sourceLabel, value:"orderSource"},
].map(opt=>(
<label
key={opt.value}
className={`
flex items-center gap-3
px-3 py-1
cursor-pointer
rounded-md
transition
hover:bg-gray-100
${sortField === opt.value ? "bg-gray-100 font-medium" : ""}
`}
>
<input
type="radio"
name="sortField"
checked={sortField===opt.value}
onChange={()=>setSortField(opt.value)}
className="w-4 h-4 accent-gray-800 cursor-pointer"
/>
{opt.label}
</label>
))}

</div>

<div className="my-2 border-t border-gray-300"></div>

{/* SECTION 3 */}
<div className="px-1 pb-1 flex flex-col">

<button
onClick={()=>{
setSortBy(sortField);
setSortDirection("asc");
setSortOpen(false);
}}
className="
flex items-center gap-2
px-3 py-2
text-sm
rounded-md
hover:bg-gray-100
transition
"
>
↑ {getAscendingLabel(sortField)}
</button>

<button
onClick={()=>{
setSortBy(sortField);
setSortDirection("desc");
setSortOpen(false);
}}
className="
flex items-center gap-2
px-3 py-2
text-sm
rounded-md
hover:bg-gray-100
transition
"
>
↓ {getDescendingLabel(sortField)}
</button>

{sortField === "orderSource" && (
<>
<div className="my-2 border-t border-gray-300"></div>

<div className="px-3 pb-2 flex items-center justify-between">

<button
onClick={()=>{
setSourceFilter("website");
setSortOpen(false);
}}
className={`p-2 rounded-md hover:bg-gray-100 transition ${
sourceFilter==="website" ? "bg-gray-100" : ""
}`}
>
<FaGlobe className="text-gray-600"/>
</button>

<button
onClick={()=>{
setSourceFilter("whatsapp");
setSortOpen(false);
}}
className={`p-2 rounded-md hover:bg-gray-100 transition ${
sourceFilter==="whatsapp" ? "bg-gray-100" : ""
}`}
>
<FaWhatsapp className="text-gray-600"/>
</button>

<button
onClick={()=>{
setSourceFilter("store");
setSortOpen(false);
}}
className={`p-2 rounded-md hover:bg-gray-100 transition ${
sourceFilter==="store" ? "bg-gray-100" : ""
}`}
>
<FaStore className="text-gray-600"/>
</button>

</div>

<button
onClick={()=>{
setSourceFilter("All");
setSortOpen(false);
}}
className="mx-3 mb-2 px-3 py-1 text-xs rounded-md bg-gray-100 hover:bg-gray-200 transition"
>
{TEXT.clearSourceFilter}
</button>

</>
)}

{sortField === "date" && (
  hasCustomDate ? (
    <button
      onClick={() => {
        setFromDate("");
        setToDate("");
        setDateOverlayOpen(false);
        setSortOpen(false);
      }}
      className="
      flex items-center gap-2
      px-3 py-2
      text-sm
      rounded-md
      hover:bg-gray-100
      transition
      "
    >
      ↺ {TEXT.resetDate}
    </button>
  ) : (
    <button
onClick={() => {
  openCustomDateModal();
  setSortOpen(false);
}}
className="
flex items-center gap-2
px-3 py-2
text-sm
rounded-md
hover:bg-gray-100
transition
"
>
<FaRegCalendarAlt className="text-gray-900 text-sm" />
{TEXT.customDate}
</button>
  )
)}

</div>

</div>
)}

{!searchOpen ? (

/* NORMAL STATUS BUTTONS */
<div className="flex items-center gap-1">

{["All","pending","paid","shipped","delivered","cancelled","refunded"].map((s)=>{

const active = statusFilter === s;

const label =
s === "All" ? TEXT.all :
s === "pending" ? TEXT.pending :
s === "paid" ? TEXT.paid || "Paid" :
s === "shipped" ? TEXT.shipped :
s === "delivered" ? TEXT.delivered :
s === "cancelled" ? TEXT.cancelled :
s === "refunded" ? TEXT.refunded || "Refunded" :
s;

return (
<button
key={s}
onClick={()=>setStatusFilter(s)}
className={`
px-3 py-[5px]
text-[13px] font-medium
rounded-md
transition
${active
? "bg-gray-200 text-gray-900"
: "text-gray-600 hover:bg-gray-200"}
`}
>
{label}
</button>
);

})}

</div>

) : (

/* SHOPIFY SEARCH BAR */
<div className="flex items-center gap-3 w-full">

<div className="
flex items-center justify-between
flex-1
h-8
px-3
bg-white
border border-gray-300
rounded-lg
shadow-sm
focus-within:border-gray-500
focus-within:ring-2
focus-within:ring-gray-200
transition
">

<div className="flex items-center gap-2 flex-1">

<FaSearch className="text-gray-400 text-sm"/>

<input
autoFocus
type="text"
value={search}
onChange={(e)=>setSearch(e.target.value)}
placeholder={TEXT.searchPlaceholder}
className="flex-1 outline-none text-sm"
/>

</div>

<div className="flex items-center gap-2">

{loading && (
<div className="w-4 h-4 border-2 border-gray-400 border-t-transparent rounded-full animate-spin"></div>
)}

<button
onClick={()=>{
setSearch("");
setSearchOpen(false);
}}
className="
w-5 h-5
flex items-center justify-center
rounded-full
border border-gray-500
text-gray-500
hover:bg-gray-100
transition
"
>
✕
</button>

</div>

</div>

{/* CANCEL BUTTON */}
<button
onClick={()=>{
setSearch("");
setSearchOpen(false);
}}
className="
px-3 h-9
mx-1
bg-white
border border-gray-300
rounded-lg
shadow-sm
hover:bg-gray-50
text-sm font-medium
"
>
{TEXT.cancel}
</button>

</div>

)}


{/* RIGHT: TOOL BUTTONS */}
<div className="flex items-center gap-2">

{loading && (
<div className="w-4 h-4 border-2 border-gray-400 border-t-transparent rounded-full animate-spin mr-2"></div>
)}

{selectedOrders.length > 0 && (
<button
onClick={() => setDeleteId("bulk")}
className="
flex items-center justify-center
w-9 h-9
bg-white
border border-gray-300
rounded-lg
shadow-[0_1px_0_rgba(0,0,0,0.05),0_2px_4px_rgba(0,0,0,0.06)]
hover:bg-gray-50
transition
"
>
<FaTrash className="text-gray-600 text-sm" />
</button>
)}

{/* SEARCH + FILTER */}
{!searchOpen && (
<button
onClick={() => setSearchOpen(true)}
className="
flex items-center justify-center gap-1
px-2 h-9
bg-white
border border-gray-300
rounded-lg
shadow-[0_1px_0_rgba(0,0,0,0.05),0_2px_4px_rgba(0,0,0,0.06)]
hover:bg-gray-50
active:shadow-[inset_0_2px_4px_rgba(0,0,0,0.08)]
transition
">

<FaSearch className="text-gray-600 text-sm" />

<svg width="14" height="14" viewBox="0 0 20 20" fill="none">
<path
d="M3 5H17M6 10H14M9 15H11"
stroke="#4B5563"
strokeWidth="1.8"
strokeLinecap="round"
/>
</svg>

</button>
)}

{/* SORT */}
<button
onClick={() => setSortOpen((v)=>!v)}
className="
sort-button
flex items-center justify-center
w-9 h-9
bg-white
border border-gray-300
rounded-lg
shadow-[0_1px_0_rgba(0,0,0,0.05),0_2px_4px_rgba(0,0,0,0.06)]
hover:bg-gray-50
active:shadow-[inset_0_2px_4px_rgba(0,0,0,0.08)]
transition
">
<span className="text-gray-600 text-sm">⇅</span>
</button>

</div>

</div>

<div className="rounded-b-[14px] overflow-visible">

<table
  dir={lang === "AR" ? "rtl" : "ltr"}
  className="w-full min-w-[800px]"
>

<thead className="bg-[#f6f6f7] text-[#6d7175] text-[13px] font-medium">
<tr>

<th className="px-3 py-2">
<input
type="checkbox"
checked={
selectedOrders.length === paginatedOrders.length &&
paginatedOrders.length > 0
}
onChange={toggleSelectAll}
className="w-4 h-4 accent-gray-800 cursor-pointer"
/>
</th>

<th className="px-4 py-2 text-start">{TEXT.orderId}</th>
<th className="px-4 py-2 text-start">{TEXT.customer}</th>
<th className="px-4 py-2 text-start">{TEXT.total}</th>
<th className="px-4 py-2 text-start">{TEXT.status}</th>
<th className="px-4 py-2 text-start">{TEXT.date}</th>

<th className="p-2 text-center">
{TEXT.shipping}
</th>

<th className="px-4 py-2 text-start rounded-tr-[14px]">{TEXT.source}</th>

</tr>
</thead>

<tbody>

{loading ? (
  <OrdersTableSkeleton />
) : sorted.length === 0 ? (
  <tr>
    <td colSpan="8">
      <EmptyOrdersState />
    </td>
  </tr>
) : (

paginatedOrders.map((o)=>(
<tr
key={o.id}
onClick={() => navigate(`/admin/orders/${o.id}`)}
className="border-b border-[#f1f1f1] hover:bg-[#f6f6f7] cursor-pointer transition"
>

<td
className="px-3 py-1.5 text-center"
onClick={(e)=>e.stopPropagation()}
>
<input
type="checkbox"
checked={selectedOrders.includes(o.id)}
onChange={() => toggleOrderSelection(o.id)}
className="w-4 h-4 accent-gray-800 cursor-pointer"
/>
</td>

<td className="px-4 py-1.5 text-[12.5px] font-medium text-gray-900">
{o.id} <span className="text-[11px] text-gray-400">({o.orderNumber})</span>
</td>

<td
className="customer-trigger group relative px-4 py-1.5 text-[13px] text-gray-800 cursor-pointer hover:bg-gray-200"
onClick={(e) => {
e.stopPropagation();
setCustomerOverlay(o.id === customerOverlay?.id ? null : o);
}}
>

<div className="flex items-center gap-1 font-medium text-gray-900">

{o.customerName}

<span className="opacity-0 group-hover:opacity-100 transition text-gray-400">
<FiChevronDown className="text-[18px]" />
</span>

</div>

{customerOverlay?.id === o.id && (
<div
className="
customer-overlay
absolute
left-0
top-full
mt-2
w-[270px]
bg-white
border border-gray-200
rounded-[14px]
shadow-[0_25px_60px_rgba(0,0,0,0.20)]
z-50
animate-sortOverlay
"
>

{/* CUSTOMER HEADER */}
<div className="px-4 pt-3 pb-2">

<div className="text-[15px] font-semibold text-gray-900 leading-tight">
{o.customerName}
</div>

{o.customerPhone && (
<div className="text-[13px] text-blue-600 mt-[2px]">
{o.customerPhone}
</div>
)}

{o.customerEmail && (
<div className="text-[12.5px] text-gray-500">
{o.customerEmail}
</div>
)}

</div>

{/* ORDERS COUNT */}
<div className="px-4 pb-3 text-[12px] text-gray-500">
{o.ordersCount ?? 0} {lang === "EN" ? "orders" : "طلبات"}
</div>

<div className="border-t border-gray-200"></div>

{/* VIEW CUSTOMER BUTTON */}
<div className="p-2">
<button
onClick={(e)=>{
e.stopPropagation();
navigate(`/admin/customers/${o.customerId}`);
}}
className="
w-full
flex items-center justify-center gap-2
h-[34px]
bg-[#f6f6f7]
border border-gray-300
rounded-lg
text-[13px] font-medium text-gray-800
shadow-[0_1px_0_rgba(0,0,0,0.05),0_3px_6px_rgba(0,0,0,0.08)]
hover:bg-gray-100
active:shadow-[inset_0_2px_4px_rgba(0,0,0,0.12)]
transition
"
>
<FaEye className="text-[12px] text-gray-600"/>

{lang === "EN" ? "View customer" : "عرض العميل"}
</button>
</div>

</div>
)}

</td>

<td
className="total-trigger group relative px-4 py-1.5 text-[13px] text-gray-800 cursor-pointer hover:bg-gray-200"
onClick={(e)=>{
e.stopPropagation();
setTotalOverlay(o.id === totalOverlay?.id ? null : o);
}}
>

<div className="flex items-center gap-1">

<div className="font-medium">

{o.discount > 0 ? (
`$${o.total.toFixed(2)}`
) : o.extraFeeAmount > 0 ? (
`$${o.total.toFixed(2)}`
) : (
`$${o.total.toFixed(2)}`
)}

</div>

<span className="opacity-0 group-hover:opacity-100 transition text-gray-400">
<FiChevronDown className="text-[18px]" />
</span>

</div>

{totalOverlay?.id === o.id && (
<div
className="
total-overlay
absolute
left-0
top-full
mt-2
w-[260px]
bg-white
border border-gray-200
rounded-[14px]
shadow-[0_25px_60px_rgba(0,0,0,0.20)]
z-50
animate-sortOverlay
"
>

{/* SUBTOTAL */}
<div className="px-4 pt-3 text-[13px] flex justify-between">
<span className="text-gray-500">
{lang === "EN" ? "Subtotal" : "المجموع الفرعي"}
</span>
<span className="font-medium">
${(o.subtotal ?? (o.total + (o.discount || 0) - (o.extraFeeAmount || 0))).toFixed(2)}
</span>
</div>

{/* DISCOUNT */}
{o.discount > 0 && (
<div className="px-4 pt-2 text-[13px] flex justify-between text-red-600">
<span>
{lang === "EN" ? "Discount" : "الخصم"}
</span>
<span>
-${o.discount.toFixed(2)}
</span>
</div>
)}

{/* EXTRA FEES */}
{o.extraFeeAmount > 0 && (
<div className="px-4 pt-2 text-[13px] flex justify-between text-green-600">
<span>
{o.extraFeeLabel || (lang === "EN" ? "Extra fee" : "رسوم إضافية")}
</span>
<span>
+${o.extraFeeAmount.toFixed(2)}
</span>
</div>
)}

{/* TOTAL */}
<div className="px-4 pt-3 pb-2 flex justify-between text-[14px] font-semibold border-t border-gray-200 mt-2">
<span>{lang === "EN" ? "Total" : "الإجمالي"}</span>
<span>${o.total.toFixed(2)}</span>
</div>

{/* VIEW ORDER */}
<div className="p-2">
<button
onClick={(e)=>{
e.stopPropagation();
navigate(`/admin/orders/${o.id}`);
}}
className="
w-full
flex items-center justify-center gap-2
h-[34px]
bg-[#f6f6f7]
border border-gray-300
rounded-lg
text-[13px] font-medium text-gray-800
shadow-[0_1px_0_rgba(0,0,0,0.05),0_3px_6px_rgba(0,0,0,0.08)]
hover:bg-gray-100
active:shadow-[inset_0_2px_4px_rgba(0,0,0,0.12)]
transition
"
>
<FaEye className="text-[12px] text-gray-600"/>
{lang === "EN" ? "View order details" : "عرض تفاصيل الطلب"}
</button>
</div>

</div>
)}

</td>

<td className="px-4 py-1.5 text-[13px] text-gray-800">
<span
className={`inline-flex items-center gap-1.5 px-2.5 py-[2px] rounded-md text-[12px] font-medium ${statusColor(o.status)}`}
>
<span className={`w-1.5 h-1.5 rounded-full ${statusDotColor(o.status)}`}></span>
{
o.status === "pending" ? TEXT.pending :
o.status === "paid" ? TEXT.paid :
o.status === "shipped" ? TEXT.shipped :
o.status === "delivered" ? TEXT.delivered :
o.status === "cancelled" ? TEXT.cancelled :
o.status === "refunded" ? TEXT.refunded :
o.status
}
</span>
</td>

<td className="px-4 py-1.5 text-[13px] text-gray-800">{formatDate(o.date)}</td>

<td className="px-3 py-1.5 text-center">
<span
className={`
inline-flex items-center justify-center
px-2.5 py-[2px]
rounded-md
text-[12px]
font-medium
border
${
  o.shippingMethod === "pickup"
    ? "bg-emerald-50 text-emerald-700 border-emerald-200"
    : "bg-blue-50 text-blue-700 border-blue-200"
}
`}
>
{o.shippingMethod === "pickup"
? lang === "EN"
? "Pickup"
: "استلام"
: lang === "EN"
? "Delivery"
: "توصيل"}
</span>
</td>

<td className="px-4 py-1.5 text-center">
<div className="flex items-center justify-center">
{orderSourceIcon(o.orderSource)}
</div>
</td>

</tr>
))

)}

</tbody>
<tfoot>
<tr className="bg-[#f6f6f7] border-t border-[#e3e3e3]">
<td
  colSpan="8"
  className={`px-4 py-1 ${lang === "EN" ? "rounded-br-[14px] rounded-bl-[14px]" : "rounded-bl-[14px] rounded-br-[14px]"}`}
>

<div className={`flex items-center justify-between text-sm text-gray-600 ${lang === "AR" ? "flex-row-reverse" : ""}`}>

{/* ORDER COUNT */}
<span className="text-gray-500 text-sm">
{filtered.length} {TEXT.orders}
</span>

{/* PAGINATION */}
<div className="flex items-center gap-0.5">

<button
onClick={() => goToOrdersPage((p) => Math.max(1, p - 1))}
disabled={currentPage === 1}
className={`w-7 h-7 flex font-bold items-center justify-center rounded-md border bg-gray-200
${currentPage === 1
  ? "opacity-40 cursor-not-allowed"
  : "hover:bg-gray-300"}
`}
>
{"<"}
</button>

<button
onClick={() => goToOrdersPage((p) => Math.min(totalPages, p + 1))}
disabled={currentPage === totalPages}
className={`w-7 h-7 flex items-center font-bold justify-center rounded-md border bg-gray-200
${currentPage === totalPages
  ? "opacity-40 cursor-not-allowed"
  : "hover:bg-gray-300"}
`}
>
{">"}
</button>

<span className="mx-2 text-gray-600 font-bold">
{currentPage}-{totalPages}
</span>

</div>

</div>

</td>
</tr>
</tfoot>
</table>
</div>
</div>           

{dateOverlayOpen && (
  <div
    className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4"
    onClick={() => setDateOverlayOpen(false)}
  >
    <div
      className="
      w-full max-w-[390px]
      bg-white
      border border-gray-200
      rounded-[18px]
      shadow-[0_30px_60px_rgba(0,0,0,0.16)]
      overflow-hidden
      animate-sortOverlay
      "
      dir={lang === "AR" ? "rtl" : "ltr"}
      onClick={(e) => e.stopPropagation()}
    >
      {/* HEADER */}
      <div className="px-5 py-4 bg-[#f6f6f7] border-b border-gray-200">
        <div className="flex items-center gap-2">
          <FaCalendarAlt className="text-gray-700 text-sm" />

          <h3 className="text-[15px] font-semibold text-gray-900">
            {lang === "EN" ? "Custom date range" : "نطاق تاريخ مخصص"}
          </h3>
        </div>

        <p className="mt-1 text-xs text-gray-500">
          {lang === "EN"
            ? "Select the start date, then select the end date."
            : "اختر تاريخ البداية ثم تاريخ النهاية."}
        </p>
      </div>

      {/* BODY */}
      <div className="p-5">
        <div className="mb-4 px-3 py-2 rounded-xl bg-gray-100 border border-gray-200 text-[12px] font-medium text-gray-800">
          {getCustomRangeLabel()}
        </div>

        <OrdersDateRangeCalendar />
      </div>

      {/* FOOTER */}
      <div className="px-5 py-4 bg-[#f6f6f7] border-t border-gray-200 flex items-center justify-between gap-3">
        <button
          type="button"
          onClick={() => {
            setCustomRangeStart(null);
            setCustomRangeEnd(null);
          }}
          className="
          h-9 px-3
          rounded-lg
          border border-gray-300
          bg-white
          text-sm font-medium text-gray-700
          hover:bg-gray-100
          transition
          "
        >
          {lang === "EN" ? "Clear" : "مسح"}
        </button>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => setDateOverlayOpen(false)}
            className="
            h-9 px-4
            rounded-lg
            border border-gray-300
            bg-white
            text-sm font-medium text-gray-700
            hover:bg-gray-100
            transition
            "
          >
            {TEXT.cancel}
          </button>

          <button
            type="button"
            disabled={!customRangeStart || !customRangeEnd}
            onClick={() => {
              setFromDate(formatLocalDateInput(customRangeStart));
              setToDate(formatLocalDateInput(customRangeEnd));
              setDateOverlayOpen(false);
            }}
            className={`
            h-9 px-4
            rounded-lg
            text-sm font-medium
            transition
            ${
              !customRangeStart || !customRangeEnd
                ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                : "bg-black text-white hover:bg-gray-900"
            }
            `}
          >
            {lang === "EN" ? "Apply" : "تطبيق"}
          </button>
        </div>
      </div>
    </div>
  </div>
)}


                    {/* DELETE MODAL */}
{deleteId !== null && (
<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">

<div className="
w-[380px]
bg-white
border border-gray-200
rounded-[14px]
shadow-[0_20px_60px_rgba(0,0,0,0.15)]
overflow-hidden
animate-sortOverlay
">

{/* HEADER */}
<div className="flex items-center gap-3 px-5 py-4 border-b border-gray-200 bg-[#f6f6f7]">

<div className="
flex items-center justify-center
w-9 h-9
rounded-full
bg-red-50
border border-red-200
">
<FaTrash className="text-red-600 text-sm"/>
</div>

<h2 className="text-[15px] font-semibold text-gray-800">
{TEXT.deleteTitle}
</h2>

</div>

{/* BODY */}
<div className="px-5 py-5 text-sm text-gray-600">
{deleteId === "bulk"
? TEXT.bulkDeleteWarning
: TEXT.deleteText}
</div>

{/* FOOTER */}
<div className="flex justify-end gap-3 px-5 py-4 border-t border-gray-200 bg-[#f6f6f7]">

<button
onClick={() => setDeleteId(null)}
className="
h-[36px] px-4
bg-white
border border-gray-300
rounded-lg
text-sm font-medium text-gray-900
hover:bg-gray-50
transition
"
>
{TEXT.cancel}
</button>

<button
onClick={()=>{
if(deleteId === "bulk"){
confirmBulkDelete();
}else{
confirmDelete();
}
}}
className="
h-[36px] px-4
bg-red-600
text-white
rounded-lg
text-sm font-medium
hover:bg-red-700
shadow-[0_1px_0_rgba(0,0,0,0.05)]
transition
"
>
{TEXT.delete}
</button>

</div>

</div>
</div>
)}
               {showToast && (
<div className="fixed bottom-6 right-6 z-[9999] animate-fadeSlide">

<div className="
flex items-center gap-3
px-4 py-3
bg-white
border border-gray-200
rounded-[12px]
shadow-[0_10px_30px_rgba(0,0,0,0.12)]
">

<div className="
flex items-center justify-center
w-7 h-7
rounded-full
bg-green-100
">
<span className="text-green-700 text-sm">✓</span>
</div>

<div className="text-sm text-gray-800 font-medium">
{lang === "EN"
? "Order deleted successfully"
: "تم حذف الطلب بنجاح"}
</div>

</div>

</div>
)}

                </main>
            </div>
        </div>
    );
}

export default AdminOrders;